// extracted by mini-css-extract-plugin
module.exports = {"toTopBtn":"index-toTopBtn-Jg-7z"};